<template>
    <slot name="form-login" v-bind="this"></slot>
</template>

<script>
export default {
    props: {
        loginUrl: { type: String, required: true },
        aceptTerms: { type: String, required: true },
        textEmailError: { type: String, required: true },
        textPasswordError: { type: String, required: true },
        routeLogout: { type: String, required: true },
        csrfToken: { type: String, required: true },
    },
    data() {
        return {
            email: '',
            password: '',
            showError: false,
            errorMessage: '',
            showErrorEmail: false,
            errorMessageEmail: '',
            showErrorPassword: false,
            errorMessagePassword: '',
            errorMessageCredentials: '',
            showAlertTerms: false,
            currentPath: '',
        }
    },

    methods: {
        validateInput(field) {
            if (field === 'email') {
                if (!this.email) {
                    this.showErrorEmail = true;
                    this.errorMessageEmail = this.textEmailError;
                } else {
                    this.showErrorEmail = false;
                    this.errorMessageEmail = '';
                }
            }

            if (field === 'password') {
                if (!this.password) {
                    this.showErrorPassword = true;
                    this.errorMessagePassword = this.textPasswordError;
                } else {
                    this.showErrorPassword = false;
                    this.errorMessagePassword = '';
                }
            }
        },

        removeError(field) {
            if (field === 'email') {
                this.errorMessageEmail = '';
                this.showErrorEmail = false;
            }
            if (field === 'password') {
                this.errorMessagePassword = '';
                this.showErrorPassword = false;
            }
        },

        termsAccepted() {
            window.location.href = this.currentPath + '?terms-accepted=1';
        },

        termsDeclined() {
            window.location.href = this.routeLogout;
        },

        handleLogin(event) {
            event.preventDefault();
            this.$emit('wait', true);
            this.showError = false;
            this.errorMessage = '';
            this.showErrorEmail = false;
            this.errorMessageEmail = '';
            this.showErrorPassword = false;
            this.errorMessagePassword = '';
            this.errorMessageCredentials = '';

            this.validateInput('email');
            this.validateInput('password');

            if (this.showErrorEmail || this.showErrorPassword) {
                this.$emit('wait', false);
                return;
            }


            const formData = new FormData();
            formData.append('email', this.email);
            formData.append('password', this.password);
            formData.append('_token', this.csrfToken);

            fetch(this.loginUrl, {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (!response.ok) {

                    return response.json().then(data => {
                        this.showError = true;
                        this.errorMessageCredentials = data.message;
                        throw new Error(data.message);

                    });
                }
                return response.json();
            })
            .then(data => {
                this.$emit('wait', false);

                let showAlert = false;


                if (!data.terms_accepted_at) {
                    showAlert = true;
                } else {
                    const termsDate = new Date(data.terms_accepted_at);
                    const currentDate = new Date();

                    const diffInYears = (currentDate.getTime() - termsDate.getTime());

                    if (diffInYears >= 31536000) {
                        showAlert = true
                    }
                }

                this.currentPath = new URL(data.redirect);

                if (showAlert) {
                    this.showAlertTerms = true
                } else {
                    window.location.href = this.currentPath;
                }
            })
            .catch(error => {
                this.$emit('wait', false);
                this.showError = true;
                this.errorMessage = error.message;
            })
        },

    },


}
</script>
